import { render, staticRenderFns } from "./ReviewRequestConfigure.vue?vue&type=template&id=197246c8&scoped=true&"
import script from "./ReviewRequestConfigure.vue?vue&type=script&lang=js&"
export * from "./ReviewRequestConfigure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197246c8",
  null
  
)

export default component.exports